import script from "./Verify.vue?vue&type=script&setup=true&lang=js"
export * from "./Verify.vue?vue&type=script&setup=true&lang=js"

import "./Verify.vue?vue&type=style&index=0&id=bdbebaf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdbebaf4"]])

export default __exports__